import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addLearnMoreLink } from '../actions';
import Modal from '../../../components/Modal';
import Button from '../../../components/Button';
import Form from '../../../components/Form';
import Input from '../../../components/Input';
import { isUrlValid } from '../../../utils/url';
import '../styles.css';

export class AddLinkModalComponent extends React.Component {
  static propTypes = {
    onCloseModal: PropTypes.func.isRequired,
    openModal: PropTypes.bool.isRequired,
    addLearnMoreLink: PropTypes.func.isRequired,
    nextLinkOrder: PropTypes.number,
  };

  state = {
    url: '',
    urlValid: false,
    name: '',
    nameValid: false,
  };

  onURLChange = (value) => {
    this.setState({ url: value, urlValid: isUrlValid(value) });
  };

  onNameChange = (value) => {
    this.setState({ name: value, nameValid: value.length > 0 && value.length <= 35 });
  };

  onAddLink = () => {
    this.props.addLearnMoreLink(this.state.url, this.state.name, this.props.nextLinkOrder);
    this.props.onCloseModal();
    this.setState({
      url: '',
      name: '',
      urlValid: false,
      nameValid: false,
    });
  };

  onCancel = () => {
    this.props.onCloseModal();
  };

  render() {
    const { nameValid, urlValid, name, url } = this.state;
    const { openModal } = this.props;
    return (
      <Modal
        as={Form}
        open={openModal}
        onSubmit={this.onAddLink}
        onClose={this.closeModal}
        styleName="add-link-modal"
      >
        <Modal.Header styleName="add-link-modal-header">
          Create a New Link
        </Modal.Header>
        <Modal.Content styleName="add-link-modal-content">
          <Form.Group inline styleName="add-link-form-group">
            <Form.Field>
              <label htmlFor="linkURL" styleName="add-link-modal-label">Link URL</label>
              <Input placeholder="http://www.example.com/learn" styleName="add-link-modal-field">
                <input
                  id="linkURL"
                  value={url}
                  onInput={(event) => this.onURLChange(event.target.value)}
                />
              </Input>
              <div styleName="input-error-wrapper">
                {url.length > 0 && !urlValid && (
                  <div styleName="input-error" data-cy="Premium-Hem-Inline-Error">
                    URL provided is not in a valid format
                  </div>
                )}
              </div>
            </Form.Field>
          </Form.Group>
          <Form.Group inline>
            <Form.Field>
              <label htmlFor="linkTitle" styleName="add-link-modal-label">Link Title</label>
              <Input placeholder="Example: Facebook" styleName="add-link-modal-field">
                <input
                  id="linkTitle"
                  value={name}
                  onInput={(event) => this.onNameChange(event.target.value)}
                />
              </Input>
              <div styleName="input-error-wrapper">
                {name.length > 35 && (
                  <div styleName="input-error" data-cy="Premium-Hem-Inline-Error">
                    Link Titles may not exceed 35 characters
                  </div>
                )}
              </div>
            </Form.Field>
          </Form.Group>
        </Modal.Content>
        <Modal.Actions>
          <Button type="button" content="Cancel" onClick={this.onCancel} />
          <Button primary content="Add Link" disabled={!nameValid || !urlValid} />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default connect(null, { addLearnMoreLink })(AddLinkModalComponent);
